// Feature flags for v1. H2H + Party are hidden by default; set the env
// vars to 'true' in .env to re-enable.

export const featureFlags = {
  h2h: (): boolean => import.meta.env.VITE_H2H_ENABLED === "true",
  party: (): boolean => import.meta.env.VITE_PARTY_ENABLED === "true",
};
